
module.exports = {
    phone:function(value){
        if(!value)return false;
        //var reg = /^1\d{10}$/;
        // 支持区号验证
        var reg = /\+(\d{2,4})-((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})))$/;
        if (!reg.test(value)) {
            return "电话号码不正确";
        }
    },
    url:function(value){
        if(!value)return false;
        var reg = /^(https?|ftp|file|ldaps|ldap):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]$/;
        if (!reg.test(value)) {
            return "url格式不正确";
        }
    },
    email:function(value){
        if(!value)return false;
        var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!reg.test(value)) {
            return "邮箱地址不正确";
        }
    },
    number:function(value){
        if(!value)return false;
        var reg = /^(\-|\+)?\d+(\.\d+)?$/;
        if (!reg.test(value)) {
            return "不是一个数字";
        }
    },
    idNumber:function(value){
        if(!value)return false;
        var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!reg.test(value)) {
            return "身份证号码不正确";
        }
    },
    
}


//////////////////
// WEBPACK FOOTER
// ./src/utiles/verifyUtils.js
// module id = 79
// module chunks = 0